import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface CommentFormFieldProps {}

export const CommentFormField: React.FC<CommentFormFieldProps> = ({}) => {
  const { control, register, watch, setValue } = useFormContext<{ comment: string }>()

  const comment = watch('comment')

  useEffect(() => {
    if (comment === '') {
      setValue('comment', undefined as unknown as string, { shouldValidate: true })
    }
  }, [comment])

  return (
    <FormField
      name="comment"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Comment</FormLabel>
              <FormError />
            </div>
            <Input {...register('comment')} placeholder={'Enter a comment'} />
          </FormItem>
        )
      }}
    />
  )
}
